import ImageZoomView from './image-zoom-view'

export default ImageZoomView
